import { Box, Button, List, ListItem, ListItemText, Stack, Typography, Chip } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import { useAppDispatch, useAppSelector, useCategoriesResources } from '@/store/hooks';
import BaseModal from '@/components/modals/BaseModal';
import CategoryIcon from '@/components/CategoryIcon';
import { close } from '@/store/uiSlice';
import { useI18nContext } from '@/i18n/i18n-react';

interface ChangeRequestRow {
    categoryName: string;
    userName: string;
    count: number;
}

const ChangeRequestsModal = () => {
    const dispatch = useAppDispatch();
    const open = useAppSelector((state) => state.ui.open.changeRequests);
    const onClose = () => dispatch(close('changeRequests'));
    const { LL } = useI18nContext();

    const rows = useAppSelector((state) => state.modal.changeRequests) as ChangeRequestRow[];
    const categories = useCategoriesResources();

    return (
        <BaseModal
            open={open}
            onClose={onClose}
            maxWidth="sm"
            title={LL.changeRequests.title()}
            actions={<Button onClick={onClose}>{LL.common.close()}</Button>}
        >
            <Box sx={{ width: '100%' }}>
                {rows.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        {LL.changeRequests.noOpen()}
                    </Typography>
                ) : (
                    <List disablePadding>
                        {rows.map((r, idx) => {
                            // Try to find a matching category by name to show its icon
                            const category = categories.find((c) => c.name === r.categoryName);

                            return (
                                <ListItem
                                    key={idx}
                                    disableGutters
                                    secondaryAction={
                                        <Stack
                                            direction="row"
                                            spacing={1}
                                            sx={{ alignItems: 'center' }}
                                        >
                                            <Chip
                                                size="small"
                                                color="warning"
                                                icon={<SyncIcon fontSize="small" />}
                                                label={String(r.count)}
                                            />
                                        </Stack>
                                    }
                                >
                                    {category && (
                                        <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
                                            <CategoryIcon
                                                category={category.icon as any}
                                                size="20px"
                                            />
                                        </Box>
                                    )}

                                    <ListItemText
                                        primary={r.categoryName}
                                        secondary={r.userName}
                                        slotProps={{
                                            primary: { sx: { fontWeight: 600 } },
                                        }}
                                    />
                                </ListItem>
                            );
                        })}
                    </List>
                )}
            </Box>
        </BaseModal>
    );
};

export default ChangeRequestsModal;
